export default __webpack_public_path__ + "static/small-7-714a599445720190d3835adc454077b4.png";